import React from "react";

import { ContactsStateContext, ContactsDispatchContext } from "./index";
import { actions } from "./store";

function useContactsState() {
  return React.useContext(ContactsStateContext);
}

function useContacts() {
  return actions(React.useContext(ContactsDispatchContext));
}

export { useContactsState, useContacts };
